import type { Moves_Bool_Exp } from '@gql/base-types';

export const buildMoveSearchFilter = (search?: string): Moves_Bool_Exp[] => {
  if (!search || !search.trim()) {
    return [];
  }

  const trimmed = search.trim();
  const term = `%${trimmed}%`;

  // A whole-number term also matches a move id exactly; '12a' stays text-only.
  const numericId = parseInt(trimmed, 10);
  const isNumeric = !isNaN(numericId) && numericId.toString() === trimmed;

  const searchConditions: Moves_Bool_Exp['_or'] = [
    { consumer_name: { _ilike: term } },
    { consumer_phone: { _ilike: term } },
    { customer: { name: { _ilike: term } } },
    { lane: { pickup: { name: { _ilike: term } } } },
    { lane: { pickup: { address: { _ilike: term } } } },
    { lane: { delivery: { name: { _ilike: term } } } },
    { lane: { delivery: { address: { _ilike: term } } } },
    { lane: { description: { _ilike: term } } },
    { reference_num: { _ilike: term } },
    { vehicle_make: { _ilike: term } },
    { vehicle_model: { _ilike: term } },
    { vehicle_stock: { _ilike: term } },
    { vehicle_vin: { _ilike: term } },
    { vehicle_year: { _ilike: term } },
  ];

  if (isNumeric) {
    searchConditions.push({ id: { _eq: numericId } });
  }

  return [{ _or: searchConditions }];
};
